export default __webpack_public_path__ + "static/media/cross_icon.2a31a80d.svg";